/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateServiceGroupSchema } from '../models/CreateServiceGroupSchema';
import type { CreateServiceSchema } from '../models/CreateServiceSchema';
import type { ServiceCategorySchema } from '../models/ServiceCategorySchema';
import type { ServiceGroupDetailSchema } from '../models/ServiceGroupDetailSchema';
import type { ServiceGroupSchema } from '../models/ServiceGroupSchema';
import type { ServiceSchema } from '../models/ServiceSchema';
import type { UpdateServiceGroupSchema } from '../models/UpdateServiceGroupSchema';
import type { UpdateServiceSchema } from '../models/UpdateServiceSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServicesApi {
    /**
     * Create Company Service
     * Create Service in my company. <br>Required Permission: 'create_service'
     * @returns ServiceSchema Created
     * @throws ApiError
     */
    public static servicesCreateCompanyServicePost({
        requestBody,
    }: {
        requestBody: CreateServiceSchema,
    }): CancelablePromise<ServiceSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/services/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Company Services
     * List my company services. <br>Required permission: list_my_company_services
     * @returns ServiceSchema OK
     * @throws ApiError
     */
    public static servicesGetCompanyServicesGet({
        isGroup,
    }: {
        isGroup?: (boolean | null),
    }): CancelablePromise<Array<ServiceSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/services/',
            query: {
                'is_group': isGroup,
            },
        });
    }
    /**
     * Get Company Grouped Services
     * List my company services, grouped. <br>Required permission: list_my_company_services
     * @returns ServiceGroupDetailSchema OK
     * @throws ApiError
     */
    public static servicesGetCompanyGroupedServicesGet(): CancelablePromise<Array<ServiceGroupDetailSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/services/grouped-services/',
        });
    }
    /**
     * Get Service Categories
     * List my company service categories. <br>Required permission: list_my_company_services
     * @returns ServiceCategorySchema OK
     * @throws ApiError
     */
    public static servicesGetServiceCategoriesGet(): CancelablePromise<Array<ServiceCategorySchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/services/categories/',
        });
    }
    /**
     * Get Company Service Group
     * Get service. <br>Required Permission: get_service_group_detail
     * @returns ServiceGroupDetailSchema OK
     * @throws ApiError
     */
    public static servicesGetCompanyServiceGroupGet({
        serviceGroupId,
    }: {
        serviceGroupId: string,
    }): CancelablePromise<ServiceGroupDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/services/groups/{service_group_id}/',
            path: {
                'service_group_id': serviceGroupId,
            },
        });
    }
    /**
     * Update Company Service Group
     * Update service group. <br>Required Permission: update_service_group
     * @returns ServiceGroupDetailSchema OK
     * @throws ApiError
     */
    public static servicesUpdateCompanyServiceGroupPut({
        serviceGroupId,
        requestBody,
    }: {
        serviceGroupId: string,
        requestBody: UpdateServiceGroupSchema,
    }): CancelablePromise<ServiceGroupDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/services/groups/{service_group_id}/',
            path: {
                'service_group_id': serviceGroupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Company Service Group
     * Delete service group. <br>Required Permission: delete_service_group
     * @returns void
     * @throws ApiError
     */
    public static servicesDeleteCompanyServiceGroupDelete({
        serviceGroupId,
    }: {
        serviceGroupId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/services/groups/{service_group_id}/',
            path: {
                'service_group_id': serviceGroupId,
            },
        });
    }
    /**
     * Get Company Service Groups
     * List my company service categories. <br>Required permission: list_my_company_services
     * @returns ServiceGroupSchema OK
     * @throws ApiError
     */
    public static servicesGetCompanyServiceGroupsGet(): CancelablePromise<Array<ServiceGroupSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/services/groups/',
        });
    }
    /**
     * Create Company Service Group
     * Create Service in my company. <br>Required Permission: 'create_service_group'
     * @returns ServiceGroupDetailSchema Created
     * @throws ApiError
     */
    public static servicesCreateCompanyServiceGroupPost({
        requestBody,
    }: {
        requestBody: CreateServiceGroupSchema,
    }): CancelablePromise<ServiceGroupDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/services/groups/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Company Service
     * Get service. <br>Required Permission: get_service_detail
     * @returns ServiceSchema OK
     * @throws ApiError
     */
    public static servicesGetCompanyServiceGet({
        serviceId,
    }: {
        serviceId: string,
    }): CancelablePromise<ServiceSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/services/{service_id}/',
            path: {
                'service_id': serviceId,
            },
        });
    }
    /**
     * Update Company Service
     * Update service. <br>Required Permission: update_service
     * @returns ServiceSchema OK
     * @throws ApiError
     */
    public static servicesUpdateCompanyServicePut({
        serviceId,
        requestBody,
    }: {
        serviceId: string,
        requestBody: UpdateServiceSchema,
    }): CancelablePromise<ServiceSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/services/{service_id}/',
            path: {
                'service_id': serviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Company Service
     * Delete service. <br>Required Permission: remove_service
     * @returns any OK
     * @throws ApiError
     */
    public static servicesDeleteCompanyServiceDelete({
        serviceId,
    }: {
        serviceId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/services/{service_id}/',
            path: {
                'service_id': serviceId,
            },
        });
    }
}
